module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "c10"
    }
  }, [_c('div', {
    staticClass: "chbrd"
  }, [_c('h1', {
    staticClass: "chapter_date"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('strong', [_vm._v("c. 500 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter_title"
  }, [_vm._v("Reciprocity")]), _vm._v(" "), _c('p', {
    staticClass: "bauthorb"
  }, [_c('strong', [_vm._v("Kong Qiu (Confucius)")]), _vm._v(" (551–479 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Confucius was a humanist in the sense that he focused mainly on practical human concerns and said very little about spiritual matters or the ultimate nature of reality. The core of his teaching deals with questions of ethics and politics. With respect to ethics, Confucius was a thinker far ahead of his time. One example of this is his doctrine of reciprocity ("), _c('em', [_vm._v("shu")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is said that one day Confucius’s disciple Tse-kung asked, “Is there one single word that can serve as a principle of conduct for life?” Confucius replied, “Perhaps the word ‘reciprocity’ will do. Do not do unto others what you do not want others to do unto you.” This is one of the earliest formulations of what is now called the Golden Rule. Most religions have some form or another of the rule. Jesus offers perhaps the most familiar version: “Always treat others as you would like to be treated” (Matthew 7:12). Confucius expressed essentially the same insight five centuries earlier, though he phrased the rule negatively (“Do "), _c('em', [_vm._v("not")]), _vm._v(" do unto others”), whereas Jesus stated it positively.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Golden Rule may or may not be the most fundamental rule of morality, but it certainly captures something very basic about the moral life. It rules out any kind of irrational special pleading of the form “It’s OK for me to do X, but not for anybody else to do it.” It also impels us to empathize with others, to see and feel things from their point of view. This capacity for empathy is critical to human moral response.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some critics reject the Golden Rule because they think it invites people to impose their own tastes and desires on other people. That, however, is a misunderstanding. What the rule really requires is that we try to imagine what it would be like to be in another person’s shoes and then to act in accordance with that person’s legitimate desires and needs. Thus understood, the Golden Rule does not compel us to satisfy desires that are, say, harmful or immoral, but only those that are reasonable and legitimate. This, of course, requires judgment, which we might get wrong. But that is true of many basic moral norms.")]), _vm._v(" "), _c('p', {
    staticClass: "captionl",
    attrs: {
      "id": "img31"
    }
  }, [_c('em', [_vm._v("This Chinese stamp from 1989, commemorating the 2,540th anniversary of Confucius’s birth, shows the great philosopher instructing his disciples.")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgb"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/31-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xref"
  }, [_c('p', {
    staticClass: "seal"
  }, [_c('span', {
    staticClass: "sls"
  }, [_c('strong', [_vm._v("SEE ALSO")])]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c09"
    }
  }, [_vm._v("Confucian Ethics (c. 500 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revival of Confucianism (c. 1180)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79bd15","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454935575_c10.vue
// module id = 102
// module chunks = 0